export default "__VITE_ASSET__BSlqP8oJ__"